<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <div class="h5">
        Modifier le chiffre d'affaires
      </div>
      <div class="text-gray-600 my-3">
        Vous pouvez valider votre modification et passer à la signature des
        déclarations, ou bien poursuivre vos modifications.
      </div>
    </div>
    <div class="col-12 col-md-9 mx-auto">
      {{ errorSub }}
      <v-input
        input-id="company-revenue"
        label="Chiffre d'affaires"
        mask="currency"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        placeholder="100 000"
        :getter-function="({ risk : { reportedRevenue } }) => reportedRevenue"
        path="risk.reportedRevenue"
      />
    </div>
    <span
      class="mx-auto col-10 mt-2"
      style="color: red; font-style: italic;"
    >
      {{ this.$store.state.contracts.updateError }}
    </span>
  </section>
</template>
<script>
import Input2 from '@/components/common/input/Input2.vue';

export default {
  name: 'ReportedRevenue',
  components: {
    'v-input': Input2,
  },
  data() {
    return {
      errorSub: this.$store.state.contracts.updateError,
    };
  },
};
</script>
